import { tns } from 'tiny-slider/src/tiny-slider'

export default () => {
  const sliderParents = document.querySelectorAll('.js-fullsize-slider-parent')
  if (!sliderParents) return
  ;[...sliderParents].forEach(sliderParent => {
    const slider = sliderParent.querySelector('.js-fullsize-slider')
    const amount = slider.dataset.slides ? slider.dataset.slides : 1
    const pager = slider.dataset.pager ? slider.dataset.pager : 1
    const activeSlider = tns({
      container: slider,
      items: Number(amount),
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: 5000,
      controls: false,
      nav: false,
      navPosition: true,
      mouseDrag: true,
      arrowKeys: true,
      rewind: false,
      loop: true
    })
    const navs = sliderParent.querySelectorAll('.js-fullsize-slider-nav')
    const next = sliderParent.querySelector('.js-fullsize-slider-next')
    const prev = sliderParent.querySelector('.js-fullsize-slider-prev')
    const info = activeSlider.getInfo()
    activeSlider.events.on('transitionEnd', e => {
      if (next != null) {
        if (e.index + 1 * amount === info.slideCount) {
          next.classList.add('inactive')
        } else {
          next.classList.remove('inactive')
        }
      }
      if (prev != null) {
        if (e.index === 0) {
          prev.classList.add('inactive')
        } else {
          prev.classList.remove('inactive')
        }
      }
    })
    ;[...navs].forEach(nav => {
      const direction = nav.dataset.direction
      nav.addEventListener('click', () => {
        if (direction === 'prev') {
          activeSlider.pause()
          activeSlider.goTo('prev')
        } else {
          activeSlider.pause()
          activeSlider.goTo('next')
        }
      })
    })
  }) // end forEach
}



// WEBPACK FOOTER //
// ./src/js/modules/FullsizeSlider.js